import { render } from "./FactoryInfo.vue?vue&type=template&id=3dbcff4f&scoped=true"
import script from "./FactoryInfo.vue?vue&type=script&lang=js"
export * from "./FactoryInfo.vue?vue&type=script&lang=js"

import "./FactoryInfo.vue?vue&type=style&index=0&id=3dbcff4f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbcff4f"]])

export default __exports__